module.exports = __webpack_public_path__ + "media/npc_dota_hero_bane.c663deb4.webm";